import { Button, Modal, Space, TextArea } from "@payping/web-components";
import { ChangeEvent, FC, useState } from "react";
import { useAppTranslation } from "@/utils/useAppTranslation";

interface Props {
  visible: boolean;
  onCancel(): void;
  onOk(notes: string): void;
}

const ManualPayNoteModal: FC<Props> = ({ visible, onCancel, onOk }) => {
  const [text, setText] = useState<string>();
  const { t } = useAppTranslation();

  const footer = (
    <Space>
      <Button onClick={onCancel}>{t("close")}</Button>
      <Button onClick={() => onOk(text || "")} type="primary">
        ثبت پرداخت نقدی
      </Button>
    </Space>
  );

  return (
    <Modal
      zIndex={100000}
      visible={visible}
      title={t("invoice.detail.cashPayment")}
      onCancel={onCancel}
      footer={footer}
    >
      <div className="tw-mb-[18px]">
        <span>توضیحات پرداخت نقدی را وارد کنید</span>
      </div>

      <TextArea value={text} onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setText(e.target.value)} />
    </Modal>
  );
};

export default ManualPayNoteModal;
